module.exports = __webpack_public_path__ + "static/media/chart-network.4396345d.svg";